import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'ngx-mat-esign360/lib/shared/shared.module';
import { SignatureFieldComponent } from 'ngx-mat-esign360/lib/document-viewer/components/signature-field/signature-field.component';
import { CheckboxFieldComponent } from 'ngx-mat-esign360/lib/document-viewer/components/checkbox-field/checkbox-field.component';
import { DocumentFieldComponent } from './components/document-field/document-field.component';
import { HammerGestureConfig, HammerModule } from '@angular/platform-browser';

@NgModule({
  declarations: [
    DocumentViewerComponent,
    SignatureFieldComponent,
    CheckboxFieldComponent,
    DocumentFieldComponent,
  ],
  imports: [CommonModule, PdfViewerModule, SharedModule, MatIconModule, HammerModule],
  exports: [
    DocumentViewerComponent,
    SignatureFieldComponent,
    CheckboxFieldComponent,
    DocumentFieldComponent,
  ],
  providers: [HammerGestureConfig],
})
export class DocumentViewerModule {}
